<template>
  <Dialog v-model:visible="visible" header="Confirmation" modal :closable="false">
    <p>{{ message }}</p>
    <template #footer>
      <button class="border border-brand_orange1 text-brand_orange1 rounded-md p-2" @click="hide">
        Cancel
      </button>
      <button class="bg-brand_orange2 rounded-md p-2" @click="confirm">
        Confirm
      </button>
    </template>
  </Dialog>
</template>

<script>
import { computed } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";

export default {
  name: "ConfirmModal",
  components: { Dialog, Button },
  props: {
    message: String,
    modelValue: Boolean,
  },
  emits: ["update:modelValue", "confirm"],
  setup(props, { emit }) {
    const visible = computed({
      get: () => props.modelValue,
      set: (val) => emit("update:modelValue", val),
    });

    const hide = () => {
      visible.value = false;
    };

    const confirm = () => {
      emit("confirm");
      hide();
    };

    return { visible, hide, confirm };
  },
};
</script>
